import React from "react";
import { Link } from "react-router-dom";

import { project_add } from 'constants/routes';

export const Intro = ()=> (
    <div className="intro">   
        <div className="container" >
            <div className="intro__img">
                <picture>
                    <source srcSet="./img/mbg1.jpg" media="(max-width: 768px)"/>
                    <img src="./img/bg1.jpg" alt="Legrand"/>
                </picture>
            </div>
            <div className="intro__content">
                <h1 className="intro__title">Вступайте в Архклуб Legrand и получайте эксклюзивные привилегии</h1>
                <p className="intro__text">
                    Если Вы архитектор или дизайнер, предлагаем Вам вступить в Архклуб Legrand, - 
                    цифровое пространство, где Вы можете зарегистрировать Ваш новый проект, получить бонусы за лояльность и 
                    продвижение нашей продукции, а также обратиться за подробной технической консультацией к специалистам Группы Legrand.
                </p>
                <a href="" download={true} className="intro__doc">
                    <img src="./img/file.svg" alt="Icon"/>
                    <span>Инструкции по работе с порталом</span>
                </a>
                <div>
                    <Link to={project_add.path} className="intro__btn">
                        Начать работу 
                    </Link>
                </div>
            </div>
        </div>
    </div>
) 


// WEBPACK FOOTER //
// ./src/components/pages/mainpage/Intro.js